import React, { useEffect, useState } from "react";
import { CUSTOMER_CONFIG } from "../../../configs";
import { X, AlertTriangle } from "lucide-react";
import { Button } from "../../../components/ui/button";
import axios from "axios";

interface InactivePopupModalProps {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}

const InactivePopupModal: React.FC<InactivePopupModalProps> = ({
  open,
  onClose,
  onOk,
}) => {
  const [inactiveDays, setInactiveDays] = useState<number>(365);

  useEffect(() => {
    if (open) {
      axios
        .get(CUSTOMER_CONFIG)
        .then((response) => {
          if (response.data && response.data.inactivityWindowDays) {
            setInactiveDays(response.data.inactivityWindowDays);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch customer config", err);
        });
    }
  }, [open]);

  const formatDuration = (days: number) => {
    if (days >= 365) {
      const years = Math.floor(days / 365);
      return `${years} year${years > 1 ? "s" : ""}`;
    }
    if (days >= 30) {
      const months = Math.floor(days / 30);
      return `${months} month${months > 1 ? "s" : ""}`;
    }
    return `${days} day${days !== 1 ? "s" : ""}`;
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="w-[420px] rounded-2xl shadow-xl p-6 relative bg-white">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={18} />
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-5">
          <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#D9D9D9]">
            <AlertTriangle className="text-[#930000]" size={22} />
          </div>
          <h2 className="text-xl font-semibold text-[#515151]">
            Account Inactivity Alert
          </h2>
        </div>

        {/* Body */}
        <div className="text-base text-[#515151] space-y-3 leading-relaxed">
          <p>
            This account has been inactive for over{" "}
            <b>{formatDuration(inactiveDays)}</b>.
          </p>
          <p>
            Please verify the customer's details before proceeding to ensure
            records remain accurate and up to date.
          </p>
        </div>

        {/* Action */}
        <div className="mt-6">
          <Button
            onClick={onOk}
            className="w-full bg-[#018752] hover:bg-[#01663f] text-white rounded-xl h-12 text-base font-medium"
          >
            Verify & Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InactivePopupModal;
